<template>
  <div class="">
    <el-drawer v-if='pcshow'
               title="我是标题"
               :visible.sync="menutopshow"
               direction="ttb"
               size="100%"
               :with-header="false">
      <img src="@/assets/buchong/last.png"
           style="height: 100%; width: 100%" />

      <div class="daohangnew">
        导航
        <a style="color: #fff">
          <img src="../assets/public/topmenu.png"
               style="width: 40px; height: 40px;"
               @click="closemenu()" /></a>
      </div>
      <Menutop></Menutop>
    </el-drawer>

    <el-drawer v-if='!pcshow'
               title="我是标题"
               :visible.sync="menutopshow"
               direction="ttb"
               size="100%"
               :with-header="false">
      <!-- publicImg.jpg -->
      <img src="@/assets/buchong/lastTop.jpg"
           style="height: 100%; width: 100%" />
      <div style="position: absolute; top: 10%; left: 5%;z-index: 1;">
        <a style="color: #fff">
          <img src="../assets/public/topmenu.png"
               style="width: 40px; height: 40px"
               @click="closemenu()" /></a>
      </div>
      <MenutopForPhone></MenutopForPhone>
    </el-drawer>

    <!-- //顶部图片 顶部图标 -->
    <div v-if='pcshow'
         style="height:473.16px;overflow:hidden">
      <a><img src="../assets/xqsimage/banner1.png"
             class="dongtai"
             style="width: 100%" /></a>

      <div class="daohangnew">
        导航
        <a @click="backIndex()">

          <img src="../assets/public/backindex.png"
               style="widthL40px;height:40px" /></a>
      </div>
      <div style="position: Absolute; top: 10%; right: 5%">
        <a @click="backXQSIndex()">
          <!-- <a-icon  type="home" style="font-size:30px" /> -->
          <img src="../assets/public/fanhuizhuye.png"
               style="width:38px;height:38px" />
        </a>
      </div>

      <!-- 顶部大标题显示   -->
      <div class="headerMenu">
        <div style="font-size:35px;color:#840207">
          <div class="company_name">{{ china }}</div>
          <div class="company_introduce">{{ english }}</div>
          <div class="company_name"
               style="margin-top:-20px">
            <img src="../assets/public/xiahua.png" />
          </div>
        </div>
      </div>
    </div>

    <!-- 手机顶部 //顶部图片 顶部图标 -->
    <div v-if='!pcshow'
         style="overflow:hidden">
      <a><img src="../assets/xqsimage/banner1.png"
             class="dongtai"
             style="width: 100%" /></a>

      <div style="position: Absolute; top: 10%; left: 5%">
        <a @click="backIndex()"><img src="../assets/public/backindex.png"
               style="width:40px;height:40px" /></a>
      </div>
      <div style="position: Absolute; top: 10%; right: 5%">
        <a @click="backXQSIndex()"><img src="../assets/public/fanhuizhuye.png"
               style="width:40px;height:40px" /></a>
      </div>

    </div>

    <!-- 菜单显示PC端 -->
    <div v-if="pcshow" class="pcMenuItem_1">
      <div class="pcMenuItem_2">
        <div v-for="item in dataList"
             :key="item.sort">
          <a href="javascript:;"  @click="rountPage(item.sort)">
            <div class="pcMenuItem_3" :style="showValue == item.sort ? 'background:rgb(107 7 7)' : ''">
              <img :src="item.icon"
                   class="marBot5" />
              {{ item.title }}
            </div>
          </a>
        </div>
      </div>
    </div>
    <!-- 菜单显示移动端 -->
    <div v-else
         style="width: 100%; background-color: rgb(227 227 227 / 84%);height:50px">
      <div class="tab">
        <div class="table-item"
             v-for="item in dataList"
             :key="item.sort">
          <span :style="showValue == item.sort ? styletable : mapStyle"
                class="tab-link"
                @click="rountPage(item.sort)">
            {{ item.title }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getZJXQSList } from '@/api/public'
import Menutop from './menutop'
import MenutopForPhone from './menutopForPhone'

export default {
  components: { Menutop, MenutopForPhone },
  props: ['showValue'],
  data () {
    return {
      menuShow: '',
      dataList: [],
      menutopshow: false,
      menuItem1Show: false,
      menuItem1show: false,
      menuItem1show: false,
      menuItem4Show: false,
      menuItem5Show: false,
      menuItem2show: false,
      showPage: false,
      pcshow: true,
      style: {},
      china: '',
      english: '',
      styletable: { color: '#fff', background: '#840207', padding: '5px', 'border-radius': '5px' },
      mapStyle: { color: '#840207', background: '#fff5e0', padding: '5px', 'border-radius': '5px' }
    }
  },
  created () {
    if (this._isPC()) {
      this.style.height = 50 + 'px'
      this.pcshow = true
    } else {
      this.pcshow = false
      window.addEventListener('scroll', this.handleScroll)
    }
    this.initZJXQS()
  },
  mounted () {

  },
  methods: {
    compare (property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    initZJXQS () {
      getZJXQSList().then(response => {
        var list = response.data
        this.dataList = list.sort(this.compare('sort'))
        this.initmenutoplist()
      })
    },
    initmenutoplist () {
      if (this.$route.query.ids == 1) {
        this.china = this.dataList[0].title
        this.english = this.dataList[0].enTitle
      } else if (this.$route.query.ids == 2) {
        this.china = this.dataList[1].title
        this.english = this.dataList[1].enTitle
      } else if (this.$route.query.ids == 3) {
        this.china = this.dataList[2].title
        this.english = this.dataList[2].enTitle
      } else if (this.$route.query.ids == 4) {
        this.china = this.dataList[3].title
        this.english = this.dataList[3].enTitle
      } else if (sessionStorage.getItem('ids') == 1) {
        this.china = this.dataList[0].title
        this.english = this.dataList[0].enTitle
      } else if (sessionStorage.getItem('ids') == 2) {
        this.china = this.dataList[1].title
        this.english = this.dataList[1].enTitle
      } else if (sessionStorage.getItem('ids') == 3) {
        this.china = this.dataList[2].title
        this.english = this.dataList[2].enTitle
      } else if (sessionStorage.getItem('ids') == 4) {
        this.china = this.dataList[3].title
        this.english = this.dataList[3].enTitle
      } else {
        this.china = this.dataList[0].title
        this.english = this.dataList[0].enTitle
      }
    },
    closemenu () {
      this.menutopshow = false
    },
    backIndex () {
      this.menutopshow = true
    },
    backXQSIndex () {
      window.location.href = 'http://www.xiqiaoshantour.com/index'
    },
    rountPage (index) {
      if (index === 1) {
        sessionStorage.setItem('ids', 1)
        this.$router.push({
          path: '/'
        })
        this.dataList[index - 1].checked = true
      }
      if (index === 2) {
        sessionStorage.setItem('ids', 2)
        this.$router.push({
          path: '/scenery'
        })
        this.dataList[index - 1].checked = true
      }
      if (index === 3) {
        sessionStorage.setItem('ids', 3)
        this.$router.push({
          path: '/Culture'
        })
        this.dataList[index - 1].checked = true
      }
      if (index === 4) {
        sessionStorage.setItem('ids', 4)
        this.$router.push({
          path: '/history'
        })
        this.dataList[index - 1].checked = true
      }
    },
    // 判断是PC端还是手机端
    _isPC () {
      var userAgentInfo = navigator.userAgent
      var Agents = [
        'Android',
        'iPhone',
        'SymbianOS',
        'Windows Phone',
        'iPad',
        'iPod'
      ]
      var flag = true
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false
          break
        }
      }
      return flag
    },
    phoneclick () {
      this.showPage = !this.showPage
    },
    handleScroll () {
      this.menuItem1Show = false
      this.menuItem1show = false
      this.menuItem1show = false
      this.menuItem4Show = false
      this.menuItem5Show = false
      this.menuItem2show = false
    },
    mouseover1 () {
      this.menuItem1Show = true
      this.menuItem1show = false
      this.menuItem1show = false
      this.menuItem4Show = false
      this.menuItem5Show = false
      this.menuItem2show = false
    },
    mouseleave1 () {
      this.menuItem1Show = false
    },
    mouseover2 () {
      this.menuItem1Show = false
      this.menuItem1show = true
      this.menuItem1show = false
      this.menuItem4Show = false
      this.menuItem5Show = false
      this.menuItem2show = false
    },
    mouseleave2 () {
      this.menuItem1show = false
    },
    mouseover3 () {
      this.menuItem1Show = false
      this.menuItem1show = false
      this.menuItem1show = true
      this.menuItem4Show = false
      this.menuItem5Show = false
      this.menuItem2show = false
    },
    mouseleave3 () {
      this.menuItem1show = false
    },
    mouseover4 () {
      this.menuItem1Show = false
      this.menuItem1show = false
      this.menuItem1show = false
      this.menuItem4Show = true
      this.menuItem5Show = false
      this.menuItem2show = false
    },
    mouseleave4 () {
      this.menuItem4Show = false
    },
    mouseover5 () {
      this.menuItem1Show = false
      this.menuItem1show = false
      this.menuItem1show = false
      this.menuItem4Show = false
      this.menuItem5Show = true
      this.menuItem2show = false
    },
    mouseleave5 () {
      this.menuItem5Show = false
    },
    mouseover6 () {
      this.menuItem2show = true
      this.menuItem1show = false
      this.menuItem1show = false
      this.menuItem4Show = false
      this.menuItem5Show = false
      this.menuItem1Show = false
    },
    mouseleave6 () {
      this.menuItem2show = false
    },
    // 美食跳转
    changeFood (infoid) {
      this.$router.push({
        // 核心语句
        path: '/food',
        query: {
          id: infoid
        }
      })
      this.showPage = false
    },
    // 概要
    changeOutline () {
      this.$router.push({
        path: '/'
      })
    },
    // 景区
    changeScenery () {
      this.$router.push({
        path: '/scenery'
      })
    },
    // 详情()
    seeInfo (infoid) {
      this.$router.push({
        path: '/sceneryInfo',
        query: {
          id: infoid
        }
      })
      this.showPage = false
    },
    // 文化
    changeCustoms () {
      this.$router.push({
        path: '/customs'
      })
    },
    // 文化详情()
    seeCustomsInfo (infoid) {
      this.$router.push({
        path: '/customsInfomation',
        query: {
          id: infoid
        }
      })
    },
    // 名人物语
    changeCelebrity () {
      this.$router.push({
        path: '/celebrity'
      })
    },
    // 名人物语详情
    seeCelebrityInfo (infoid) {
      this.$router.push({
        path: '/celebrityInfomation',
        query: {
          id: infoid
        }
      })
      this.showPage = false
    },
    // 名胜区
    changeScenicSpots () {
      this.$router.push({
        path: '/scenicSpots'
      })
    },
    // 情报
    changeInfo () {
      this.$router.push({
        path: '/information'
      })
    },
    // 道路
    changeRoad () {
      this.$router.push({
        path: '/road'
      })
    },
    // 历史
    changeHistory () {
      this.$router.push({
        path: '/history'
      })
    }
  }
}
</script>

<style>
/* .daohangnew {
  position: absolute;
  top: 10%;
  left: 5%;
  width: 100px;
  background: #870a0a;
  border-radius: 20px;
  font-size: 14px;
  color: #fff;
  padding-left: 5px;
} */
.dongtai {
  visibility: visible !important;
  -webkit-animation: scaleUpDown 2s forwards
    cubic-bezier(0.25, 0.46, 0.45, 0.94);
  animation: scaleUpDown 2s forwards cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
@-webkit-keyframes scaleUpDown {
  from {
    -webkit-transform: scale(1.18);
    transform: scale(1.18);
  }
  to {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes scaleUpDown {
  from {
    -webkit-transform: scale(1.18);
    transform: scale(1.18);
  }
  to {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
li {
  margin-bottom: 10px;
  color: #7f7f7f;
}
.folatL30 {
  float: left;
  width: 30%;
}
a {
  color: #7f7f7f;
}

.marBot5 {
  margin-bottom: 5px;
  margin-right: 10px;
}
.top {
  /* 设置宽度高度背景颜色 */
  height: auto; /*高度改为自动高度*/
  width: 100%;
  margin-left: 0;
  height: 112px;
  background: #e6e6e6;
  /* background: white; */
  position: absolute; /*固定在顶部*/
  top: 0; /*离顶部的距离为0*/
}
.logo {
  position: absolute;
  z-index: 999;
}
.top ul {
  /* 清除ul标签的默认样式 */
  width: auto; /*宽度也改为自动*/
  list-style-type: none;
  white-space: nowrap;
  overflow: hidden;
  font-size: 18px;
  margin: 0px;
  margin-left: calc(50vw - 656px);
  /* margin-top: 0;          */
}
.top li {
  float: left; /* 使li内容横向浮动，即横向排列  */
  margin-right: 2%; /* 两个li之间的距离*/
  text-align: center;
  line-height: 30px;
  position: relative;
  overflow: hidden;
}

.top li a {
  /* 设置链接内容显示的格式*/
  display: block; /* 把链接显示为块元素可使整个链接区域可点击 */
  text-align: center;
  overflow: hidden;
  text-decoration: none; /* 去除下划线 */
  font-weight: 400;
  color: #333333;
  font-family: "Microsoft YaHei";
  padding: 0px;
  padding-top: 41px;
  padding-bottom: 41px;
}
.top li a:hover {
  /* 鼠标选中时背景变为黑色 */
  /* background-color: #111; */
  color: #840207;
}
.top ul li ul {
  /* 设置二级菜单 */
  margin-left: -0.2px;
  background: rgb(189, 181, 181);
  position: relative;
  display: none; /* 默认隐藏二级菜单的内容 */
  width: 100px;
}
.top ul li ul li {
  /* 二级菜单li内容的显示 */

  float: none;
  text-align: center;
}
.top ul li:hover ul {
  /* 鼠标选中二级菜单内容时 */
  display: block;

  height: 512px;
  background: #9c242a;
  border-radius: 10px;
}
.menuItem6 {
  width: 348px;
  height: 512px;
  background: #9c242a;
  border-radius: 10px;
  position: fixed;
  z-index: 999;
  margin-top: 13px;
}
.menuItem1 {
  width: 348px;
  height: 258px;
  background: #9c242a;
  border-radius: 10px;
  position: fixed;
  z-index: 999;
  margin-top: 13px;
}
.menuItem2 {
  width: 348px;
  height: 158px;
  background: #9c242a;
  border-radius: 10px;
  position: fixed;
  z-index: 999;
  margin-top: 13px;
}
.menuItem3 {
  width: 600px;
  height: 330px;
  background: #9c242a;
  border-radius: 10px;
  position: fixed;
  z-index: 999;
  margin-top: 13px;
}
.menuItem4 {
  width: 348px;
  height: 360px;
  background: #9c242a;
  border-radius: 10px;
  position: fixed;
  z-index: 999;
  margin-top: 13px;
}
.menuItem5 {
  width: 348px;
  height: 380px;
  background: #9c242a;
  border-radius: 10px;
  position: fixed;
  z-index: 999;
  margin-top: 13px;
}
.secondMenuItemFont {
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #e6e6e6;
  line-height: 30px;
  text-align: left;
}

.firstMenufont {
  font-size: 18px;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #e6e6e6;
  line-height: 40px;
  cursor: pointer;
}
.firstMenufontMobile {
  font-weight: 300;
  font-size: 14px;
  font-family: "Microsoft YaHei";
}
.tab {
  white-space: nowrap;
  /* height: 3rem;
  line-height: 1.466666666666667rem; */
  /* font-size: 0.7rem; */
  overflow-y: hidden;
  /* padding-top: 10px; */
  text-align: left;
  padding-left: 4%;
}
.tab .table-item {
  height: 50px;
  line-height: 50px;
  display: inline-block;
  font-size: 14px;
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  /* padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: inline-block; */
}

/*定义一个名字为lefteaseinAnimate动画，实现从页面的左边淡入页面效果*/
@keyframes lefteaseinAnimate {
  0% {
    transform: translateX(-2000px);
    opacity: 0;
  } /*在0%时设置文字在想X轴-2000px位移处（左边），透明度为0，也就是看不见文字*/
  100% {
    transform: translateX(0px);
    opacity: 1;
  } /*在100%时设置文字在想X轴0px位移处，也就是原始布局的位置，透明度为1，也就是文字可以看见了*/
}
@-webkit-keyframes lefteaseinAnimate {
  0% {
    -webkit-transform: translateX(-2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
@-o-keyframes lefteaseinAnimate {
  0% {
    -webkit-transform: translateX(-2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
@-ms-keyframes lefteaseinAnimate {
  0% {
    -webkit-transform: translateX(-2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
@-moz-keyframes lefteaseinAnimate {
  0% {
    -webkit-transform: translateX(-2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
.company_name {
  animation: lefteaseinAnimate 2s ease 1; /*调用已定义好的动画lefteaseinAnimate，全程运行时间1S，进入的速度曲线为ease，只播放一次*/
  -webkit-animation: lefteaseinAnimate 2s ease 1;
  -ms-animation: lefteaseinAnimate 2s ease 1;
  -o-animation: lefteaseinAnimate 2s ease 1;
  -moz-animation: lefteaseinAnimate 2s ease 1;

  /*规定动画的最后状态为结束状态*/
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  -o-animation-fill-mode: forwards;
  -ms-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
}

/*定义一个名字为righteaseinAnimate动画，实现从页面的右边淡入页面效果*/
@keyframes righteaseinAnimate {
  0% {
    transform: translateX(2000px);
    opacity: 0;
  } /*在0%时设置文字在想X轴2000px位移处（右边），透明度为0，也就是看不见文字*/
  100% {
    transform: translateX(0px);
    opacity: 1;
  } /*在100%时设置文字在想X轴0px位移处，也就是原始布局的位置，透明度为1，也就是文字可以看见了*/
}
@-webkit-keyframes righteaseinAnimate {
  0% {
    -webkit-transform: translateX(2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
@-o-keyframes righteaseinAnimate {
  0% {
    -webkit-transform: translateX(2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
@-ms-keyframes righteaseinAnimate {
  0% {
    -webkit-transform: translateX(2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
@-moz-keyframes righteaseinAnimate {
  0% {
    -webkit-transform: translateX(2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
.company_introduce {
  animation: righteaseinAnimate 2s ease 1; /*调用已定义好的动画righteaseinAnimate，全程运行时间1S，进入的速度曲线为ease，只播放一次*/
  -webkit-animation: righteaseinAnimate 2s ease 1;
  -moz-animation: righteaseinAnimate 2s ease 1;
  -ms-animation: righteaseinAnimate 2s ease 1;
  -o-animation: righteaseinAnimate 2s ease 1;

  /*规定动画的最后状态为结束状态*/
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  -o-animation-fill-mode: forwards;
  -ms-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
}
.headerMenu {
  position: Absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px;
  text-align: left;
}
.pcMenuItem_1 {
  width: 100%;
  background-color: rgb(227 227 227 / 84%);
}
.pcMenuItem_2 {
  margin: 0px auto;
  height: 56px;
  width: 1200px;
  background-color: #840207;
  font-size: 14px;
}
.pcMenuItem_3 {
  float: left;
  width: 300px;
  height: 56px;
  text-align: center;
  line-height: 56px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue